import { useSelector } from 'react-redux';
import './QuestionStatusIndicator1.css'; // File CSS mới

function QuestionStatusIndicator() {
  const { questions, chosenCalibrationId } = useSelector(state => state.calibration);

  // Tạo mảng trạng thái trả lời întâi: true (đúng), false (sai), null (chưa trả lời)
  const answerStatuses = questions.map(question => question?.isCorrect ?? null);

  // Hàm chia mảng thành các set với 4-5 câu hỏi mỗi set
  const splitIntoSetsWithRange = (arr) => {
    const totalLength = arr.length;
    if (totalLength <= 0) return [];

    const sets = [];
    let remaining = [...arr];
    let startIndex = 0;
    let endIndex = 0;
    for (let i = 0; i < chosenCalibrationId.length; i++) {
      startIndex = endIndex;
      const numberOfQuestions = chosenCalibrationId[i].numberOfQuestions;
      endIndex = startIndex + numberOfQuestions;
      sets.push(remaining.slice(startIndex, endIndex));
    }

    return sets;
  };

  // Chia answerStatuses thành các set với 4-5 câu hỏi
  const sets = splitIntoSetsWithRange(answerStatuses);

  // Tính chỉ số toàn cục để xác định câu hỏi hiện tại
  let globalIndex = 0;

  return (
    <div className="question-indicator">
      {sets.map((set, setIndex) => (
        <div key={setIndex} className="question-set">
          {set.map((status, index) => {
            const currentGlobalIndex = globalIndex;
            globalIndex++; // Tăng chỉ số toàn cục

            // Xác định lớp trạng thái dựa trên status
            let statusClass = 'status-rect unanswered'; // Mặc định là unanswered
            if (status === true) {
              statusClass = 'status-rect correct';
            } else if (status === false) {
              statusClass = 'status-rect incorrect';
            }

            return (
              <div
                key={index}
                className={statusClass}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}

export default QuestionStatusIndicator;